export default "__VITE_ASSET__OOsyKteu__"